const INVITATION = "INVITATION";
const NO_GROUP = "NO_GROUP";
const HAS_GROUP = "HAS_GROUP";
const USER_IS_LOCKED = "User is locked";

const GROUP_ACTIONS_FAILED = {
  DELETE_GROUP_FAILED: "deleteGroup",
  CREATE_GROUP_FAILED: "createGroup",
  OFLC_REMOVE_USER_FROM_GROUP_FAILED: "removeUserFromGroup",
  OFLC_ACCEPTE_INVITATION_FAILED: "acceptInvitation",
};

const USER_ERROR_MESSAGE = "UserErrorMessage";

const MOMENT_UNITS = {
  YEARS: "years",
  QUARTERS: "quarters",
  MONTHS: "months",
  WEEKS: "weeks",
  DAYS: "days",
  HOURS: "hours",
  MINUTES: "minutes",
  SECONDS: "seconds",
  MILLISECONDS: "milliseconds",
};

const WAGE_MULTIPLIERS = {
  HOURLY: 2080, // 52 weeks times 40 hours per week
  WEEKLY: 52, // 52 weeks in a year
  BIWEEKLY: 26, // 52 weeks divided by 2
  MONTHLY: 12, // 12 months in a year
  ANNUAL: 1, // 1 year
};

export {
  INVITATION,
  NO_GROUP,
  HAS_GROUP,
  GROUP_ACTIONS_FAILED,
  USER_IS_LOCKED,
  USER_ERROR_MESSAGE,
  MOMENT_UNITS,
  WAGE_MULTIPLIERS,
};
